import OrganizationModel from "src/models/OrganizationModel";
import PrivateSerieModel from "src/models/PrivateSerieModel";
import UserModel from "src/models/UserModel";
import renderEmail from "src/utils/renderEmail";

interface LessonSeriesPostingEmailInput {
  organization: OrganizationModel;
  instructor: UserModel;
  admin: UserModel;
  privateSerie: PrivateSerieModel;
}

interface LessonSeriesPostingVars {
  adminEmail: string;
  adminFullName: string;
  firstName: string;
  organizationName: string;
  studentNames: string;
  type: string;
  url: string;
}

const LessonSeriesPosting = (vars: LessonSeriesPostingVars) => ({
  type: `LessonSeriesPosting`,
  subject: `Lesson Series Available - ${vars.organizationName}`,
  html: `<p>${vars.firstName},</p>

<p>A ${vars.type} (${vars.studentNames}) has been posted and is available for claiming.</p>

<p>This series is available first come, first served to eligible instructors. If you have any questions, please contact ${vars.adminFullName} at ${vars.adminEmail}.</p>

<p><a href="${vars.url}">View ${vars.type}</a></p>

<p>Sincerely,<br />
${vars.adminFullName}</p>`,
  sms: `${vars.type} registration with ${vars.studentNames} is available for claim. Sent by ${vars.adminFullName}. ${vars.url}`,
});

export default ({
  organization,
  instructor,
  admin,
  privateSerie,
}: LessonSeriesPostingEmailInput) => {
  const template = LessonSeriesPosting;

  const studentNames = privateSerie.roster.map((s) => {
    return `${s.firstName} ${s.lastName}`;
  });

  const variables: LessonSeriesPostingVars = {
    adminEmail: admin.email,
    adminFullName: `${admin.firstName} ${admin.lastName}`,
    firstName: instructor.firstName,
    organizationName: organization.title,
    studentNames: studentNames.join(", "),
    type: privateSerie.offering.type,
    url: `https://${organization.subdomain}.captyn.com/admin/custom-private-lessons/${privateSerie.id}/claim`,
  };

  const email = renderEmail({
    template,
    variables,
  });

  return email;
};
